import moment from "moment";
import {
  divisionFilter,
  activityFilter,
  statusFilter,
  priorityFilter,
  commonFilter,
  emailerFilter
} from "./columnFilters";

function readableDate(date) {
  return date
    ? new Date(date).getDate() +
    " " +
    new Date(date).toLocaleString("default", { month: "long" }) +
    " " +
    new Date(date).getFullYear()
    : "";
}
//to update table row


//react-table follows specific structure.
//Header is the title of the column.

//accessor can be both function or property. When provided a string, it will access that function/property
// from the response data

export const COLUMNS = [
  {
    Header: "Division",
    accessor: "Division",
    Filter: commonFilter,
  },
  {
    Header: "Received Date",
    accessor: "Received Date",
    Cell: ({ value }) => {
      return readableDate(value);
    },
    Filter: commonFilter,
  },
  {
    Header: "ETA (in hours)",
    accessor: "Estimated Hours",
    Cell: ({ value }) => {
      return value || '-';
    },
    Filter: commonFilter,
  },
  {
    Header: "ETA Date",
    accessor: "End Date",
    Cell: ({ value }) => {
      return moment(value).format("DD/MM/YYYY hh:mm A") || '-';
    },
    Filter: commonFilter,
  },
  {
    Header: "Activity Type",
    accessor: "Activity Type",
    Filter: activityFilter,
  },
  {
    Header: "Number of VAs",
    accessor: "Number of VAs",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Static Slides",
    accessor: "Static Slides",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Interactive Slides",
    accessor: "Interactive Slides",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Adaption Slides",
    accessor: "Adaption Slides",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Emailer/Landing Page Type",
    accessor: "Emailer Type",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: emailerFilter,
  },
  {
    Header: "Number of Pages",
    accessor: "Number of Pages",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Task/Emailer/Landing Page Name",
    accessor: "Task Name",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Emailer/Landing Page Subject",
    accessor: "Emailer Subject",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Add Link",
    accessor: "Add Link",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Priority",
    accessor: "Priority",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: priorityFilter,
  },
  {
    Header: "Status",
    accessor: "Status",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: statusFilter,
  },
  {
    Header: "Final Delivery",
    accessor: "Final Delivery",
    Cell: ({ value }) => {
      return readableDate(value);
    },
    Filter: commonFilter,
  },
  {
    Header: "Vistaar SPOC",
    accessor: "Vistaar SPOC",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Vistaar Developer",
    accessor: "Vistaar Developers",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "BU SPOC",
    accessor: "BU SPOC",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "BU SPOC Email",
    accessor: "BU SPOC Email",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: "Comments",
    accessor: "Comments",
    Cell: ({ value }) => {
      return value || '-'
    },
    Filter: commonFilter,
  },
  {
    Header: 'ID',
    id: "id",
    accessor: "id",
    Filter: commonFilter
  }
];
